export default "__VITE_ASSET__CHXwIStL__"